<template>
<div id="contentbg">
    <div class="tonglan">
        <div class="yjdjs">
            <div class="rznav">
                <div :class="reg.name === curRegType ? reg.curClass : reg.class" v-for="reg in regTypes" :key="reg.name"><a @click="changeRegType(reg)" href="javascript:void(0)">成为{{reg.name}}</a></div>
                <div class="clear"></div>
            </div>
            <div class="buyer">
                <h3>成为{{curRegType}}</h3>
                <router-view />
            </div>
        </div>
    </div>
</div>
</template>
<script>

export default {
  name: 'Enter',
  data () {
    return {
      curRegType: '买家',
      regTypes: [
        { name: '买家', url: 'Buyer', class: 'cwmybg', curClass: 'cwmy' },
        { name: '卖家', url: 'Saler', class: 'cwmjbg', curClass: 'cwmj' },
        { name: '区域经理', url: 'Partner', class: 'cwjlbg', curClass: 'cwjl' }
      ]
    }
  },
  methods: {
    changeRegType (reg) {
      this.curRegType = reg.name
      this.$router.push({ path: reg.url })
    }
  }
}
</script>
